import React from "react";
import { CommonModule } from "uca-react-containers-library";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import history from "./history";
import "react-datepicker/dist/react-datepicker.css";
import { Help } from "./components/pages/help";
import { AllFaq } from "./components/pages/allfaq";
import FaqDetail from "./components/pages/faq/faq-detail";
import { CommonContext } from "./components/context/common-context";
import { initUserInfo } from "./helpers/common";
import { Rewards } from "./components/pages/rewards";
import ScrollToTop from "./scrollToTop";
import NotFound from "./components/pages/not-found/not-found";
import Analytics from "./analytics";
import ContactUs from "./components/pages/contactus/contactus";
import { routes, allCategoryLists } from "./components/pages/help/constants";
import Orders from "./components/pages/orders/orders";
import BANNER_MAPPING from "./components/data/mapping.json";
import FAQ from "./components/data/faq.json";

function App() {
  window.addEventListener("popstate", (event) => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  });

  const { appData } = CommonModule.useApp();
  const { questions } = BANNER_MAPPING[appData.banner];
  const bannerCategories = allCategoryLists.filter((lists) => lists.banner && lists.banner.includes(appData.banner));
  const bannerFAQ = FAQ.filter(({id}) => questions.includes(id));
  const appTheme = `theme-${appData.theme}`;
  const user = initUserInfo();
  const isGuest =
    !(user && user.loginStatus) ||
    (user && user.loginStatus && user.loginStatus.includes("guest"));
  const faqPaths = Object.values(routes)
    .filter((item) => item !== "orders")
    .map((route) => "/" + route);
  const isFeedbackAllowed = new Date() < new Date('2023-02-05');

  return (
    <CommonContext.Provider value={{ user, appData, isGuest, bannerCategories, bannerFAQ, isFeedbackAllowed }}>
      <Router basename="/help" history={history}>
        <main className={appTheme}>
          <div
            className="container-fluid"
            style={{ background: "#FAF8F7", marginBottom: "-94px" }}
          >
            <div className="row">
              <div className="col-12">
                <ScrollToTop />
                <Switch>
                  <PrivateRoute
                    exact
                    path={["/home", "/help.html"]}
                    title={`Help`}
                    banner={appData.banner}
                    component={Help}
                  />
                  <PrivateRoute
                    exact
                    path={["/contactus"]}
                    title={`Contact Us`}
                    banner={appData.banner}
                    component={ContactUs}
                  />
                  <PrivateRoute
                    exact
                    path={["/rewards.html"]}
                    title={`Rewards`}
                    banner={appData.banner}
                    component={Rewards}
                  />
                  <PrivateRoute
                    exact
                    path={faqPaths}
                    dynamicTitle={true}
                    title={`All Faq`}
                    banner={appData.banner}
                    component={AllFaq}
                  />
                  <PrivateRoute
                    exact
                    path={["/faq-detail/:id/:questionid"]}
                    title={`Faq Detail`}
                    banner={appData.banner}
                    component={FaqDetail}
                  />
                  <PrivateRoute
                    exact
                    path={["/not-found"]}
                    title={`Not Found`}
                    banner={appData.banner}
                    component={NotFound}
                  />
                  <PrivateRoute
                    exact
                    path={["/orders"]}
                    title={`Orders`}
                    banner={appData.banner}
                    component={Orders}
                  />
                </Switch>
                <Analytics />
              </div>
            </div>
          </div>
        </main>
      </Router>
    </CommonContext.Provider>
  );
}

export default App;
